import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export function TwitterIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 25" {...props}>
      <path d="M12.001 0.492188C18.5759 0.492188 23.9062 5.82251 23.9062 12.3975C23.9062 18.9724 18.5759 24.3027 12.001 24.3027C5.42603 24.3027 0.0957033 18.9724 0.0957031 12.3975C0.0957031 5.82251 5.42603 0.492188 12.001 0.492188ZM5.7168 6.98145L10.4678 13.0908L5.96484 18.1514H7.89355L11.3682 14.2471L14.4053 18.1514H18.2832L13.3311 11.7129L17.541 6.98145H15.6143L12.4385 10.5508L9.69336 6.98145H5.7168ZM9.11328 8.05664L16.0049 17.0176H14.9375L7.9668 8.05664H9.11328Z" />
    </SvgIcon>
  );
}
